import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';
import EmojiPicker, { EmojiClickData, Categories } from 'emoji-picker-react';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
}

const CountryFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
}) => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));
  const [isPickerOpen, setIsPickerOpen] = useState<boolean>(false);

  const toggleEmojiPicker = () => {
    setIsPickerOpen((prev) => !prev);
  };

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    setFieldValue('emoji', emojiData?.emoji);
    setIsPickerOpen((prev) => !prev);
  };

  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        setIsPickerOpen(false);
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>Country</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='labelEn'
                name='labelEn'
                label='Label English'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.labelEn}
                error={Boolean(errors.labelEn && touched.labelEn)}
                helperText={
                  Boolean(errors.labelEn && touched.labelEn) && errors.labelEn
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='labelAr'
                name='labelAr'
                label='Label Arabic'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.labelAr}
                error={Boolean(errors.labelAr && touched.labelAr)}
                helperText={
                  Boolean(errors.labelAr && touched.labelAr) && errors.labelAr
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='emoji'
                name='emoji'
                label={'Emoji'}
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.emoji}
                error={Boolean(errors.emoji && touched.emoji)}
                helperText={
                  Boolean(errors.emoji && touched.emoji) && errors.emoji
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton onClick={toggleEmojiPicker}>
                        <InsertEmoticonIcon />
                      </IconButton>
                      {isPickerOpen && (
                        <Box
                          position='absolute'
                          zIndex={1}
                          right={'50px'}
                          top={'-275%'}
                          style={{ width: isXsScreen ? '200px' : 'auto' }}
                        >
                          <EmojiPicker
                            onEmojiClick={handleEmojiClick}
                            categories={[
                              // {
                              //   name: 'Smileys & Emotion',
                              //   category: Categories.SMILEYS_PEOPLE,
                              // },
                              { name: 'Flags', category: Categories.FLAGS },
                              // {
                              //   name: 'Food  & Drink',
                              //   category: Categories.FOOD_DRINK,
                              // },
                            ]}
                            skinTonesDisabled={true}
                            style={{
                              width: isXsScreen ? '200px' : 'auto',
                              height: '350px',
                            }}
                          />
                        </Box>
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              {/* <FormControl
                fullWidth
                error={Boolean(touched?.emoji && errors?.emoji)}
              >
                <InputLabel>{'Emoji'}</InputLabel>
                <Select
                  name='emoji'
                  labelId='emoji'
                  id='emoji'
                  value={values.emoji}
                  label={'Emoji'}
                  onChange={(e) => setFieldValue('emoji', e.target.value)}
                  MenuProps={{
                    style: {
                      maxHeight: 400,
                    },
                  }}
                >
                  {COUNTRY_FLAGS?.map((country) => (
                    <MenuItem
                      key={country.value}
                      value={country.value}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: country.value }}
                      />
                      &nbsp;&nbsp;({country.name})
                    </MenuItem>
                  ))}
                </Select>
                {Boolean(touched.emoji && errors.emoji) && (
                  <FormHelperText>{errors?.emoji}</FormHelperText>
                )}
              </FormControl> */}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='code'
                name='code'
                label={'Code'}
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.code}
                error={Boolean(errors.code && touched.code)}
                helperText={Boolean(errors.code && touched.code) && errors.code}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    name='activeState'
                    onChange={(e) =>
                      setFieldValue('activeState', e.target.checked)
                    }
                    checked={values.activeState}
                  />
                }
                label={'Active Status'}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              setIsPickerOpen(false);
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CountryFormModal;
